/** Matches {{ token }} with optional surrounding whitespace. */
const TOKEN = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);
}

/** Every merge token used in a template, in first-appearance order. */
export function extractTokens(template: string): string[] {
  const found = new Set<string>();
  for (const match of template.matchAll(TOKEN)) found.add(match[1]);
  return Array.from(found);
}

/** Tokens a template uses that no CSV column supplies. */
export function findUnknownTokens(template: string, available: string[]): string[] {
  const known = new Set(available);
  return extractTokens(template).filter((token) => !known.has(token));
}

/**
 * Substitutes merge tokens. Values are HTML-escaped when `asHtml` is set, so a
 * recipient named `O'Brien & Sons <Ltd>` can never break or inject markup.
 * Unknown tokens collapse to an empty string rather than leaking `{{token}}`
 * into a sent email.
 */
export function applyMerge(
  template: string,
  data: Record<string, string>,
  asHtml: boolean,
): string {
  return template.replace(TOKEN, (_full, token: string) => {
    const value = data[token] ?? '';
    return asHtml ? escapeHtml(value) : value;
  });
}
